<template>
  <div class="user_table">
    <el-dialog :visible.sync="outerVisible" title="用户详情">
      <div class="outer">
        <div class="outer_left">
          <div>
            <span class="span_one">用户名</span>
            <span class="span_two color_plus">{{detail_obj.name}}</span>
          </div>
          <div>
            <span class="span_one">手机号</span>
            <span class="span_two">{{detail_obj.mobile}}</span>
          </div>
          <div>
            <span class="span_one">机型</span>
            <span class="span_two">{{detail_obj.deviceModel}}</span>
          </div>
          <div class="org_div">
            <span class="span_one oneplus">所在组织</span>
            <span class="span_two twoplus">
              <div class="span_block color_plus" v-for="item in organizaList" :key="item">
                <span>{{item.name}}</span>
              </div>
              <div style="clear:both"></div>
            </span>
          </div>
          <div>
            <span class="span_one">注册时间</span>
            <span class="span_two">{{detail_obj.createTime}}</span>
          </div>
          <div>
            <span class="span_one">注册地点</span>
            <span class="span_two">{{detail_obj.city}}</span>
          </div>
        </div>
        <div class="outer_right">
          <div class="top_title">使用情况</div>
          <div class="use_list">
            <div class="list_item">
              <div class="title">担当考勤</div>
              <div class="content">
                <div class="content_item spacial_item">
                  <div class="item_one"></div>
                  <span v-if="info.attendanceTime">{{dayjs(info.attendanceTime).format('YYYY-MM-DD HH:mm')}}</span>
                </div>
                <div class="content_item">
                  <div class="item_two"></div>
                  <span>{{info.attendanceIp}}</span>
                </div>
                <!-- <div class="content_item">
                  <div class="item_three"></div>
                  <span>{{detail_pro.attendanceClientType}}</span>
                </div> -->
              </div>
            </div>
            <div class="list_item">
              <div class="title">担当审批</div>
              <div class="content">
                <div class="content_item spacial_item">
                  <div class="item_one"></div>
                  <span v-if="info.approveTime">{{dayjs(info.approveTime).format('YYYY-MM-DD HH:mm')}}</span>
                </div>
                <div class="content_item">
                  <div class="item_two"></div>
                  <span>{{info.approveIp}}</span>
                </div>
                <!-- <div class="content_item">
                  <div class="item_three"></div>
                  <span>{{detail_pro.workflowType}}</span>
                </div> -->
              </div>
            </div>
            <!-- <div class="list_item">
              <div class="title">担当任务</div>
              <div class="content">
                <div class="content_item spacial_item">
                  <div class="item_one"></div>
                  <span>{{detail_pro.taskTime}}</span>
                </div>
                <div class="content_item">
                  <div class="item_two"></div>
                  <span>{{detail_pro.taskIp}}</span>
                </div>
                <div class="content_item">
                  <div class="item_three"></div>
                  <span>{{detail_pro.taskClientType}}</span>
                </div>
              </div>
            </div>
            <div class="list_item">
              <div class="title">担当企业云盘</div>
              <div class="content">
                <div class="content_item spacial_item">
                  <div class="item_one"></div>
                  <span>{{detail_pro.clouddiskTime}}</span>
                </div>
                <div class="content_item">
                  <div class="item_two"></div>
                  <span>{{detail_pro.clouddiskIp}}</span>
                </div>
                <div class="content_item">
                  <div class="item_three"></div>
                  <span>{{detail_pro.clouddiskClientType}}</span>
                </div>
              </div>
            </div>
            <div class="list_item">
              <div class="title">担当云资产</div>
              <div class="content">
                <div class="content_item spacial_item">
                  <div class="item_one"></div>
                  <span>{{detail_pro.amsTime}}</span>
                </div>
                <div class="content_item">
                  <div class="item_two"></div>
                  <span>{{detail_pro.amsIp}}</span>
                </div>
                <div class="content_item">
                  <div class="item_three"></div>
                  <span>{{detail_pro.amsClientType}}</span>
                </div>
              </div>
            </div> -->
          </div>
          <div
            class="bottom_content"
          >最后一次使用——{{detail_pro.dateformat}} {{detail_obj.city}} {{detail_obj.deviceModel}}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { user_detail } from "../../../api/user";
import dayjs from "dayjs";
export default {
  data() {
    return {
      outerVisible: false,
      detail_obj: {},
      detail_pro: {},
      organizaList: [],
      info:{},
    };
  },
  methods: {
    dayjs,
    init(a) {
      this.outerVisible = true;
      this.detail_obj = a;
      let data = {
        userId: a.userId
      };
      user_detail(data)
        .then(res => {
          // this.detail_obj.push((organizaList = res.data.organizaList));
          this.info = res.data;
          this.organizaList = res.data.organizaList;
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.user_table {
  /deep/.el-dialog {
    width: 740px;
    @include dia_header_usual;
  }
  .outer {
    display: flex;
    border-top: 1px solid #f4f4f4;
    .outer_left {
      flex: 1;
      border-right: 1px solid #f4f4f4;
      padding: 40px 20px 20px 40px;
      .org_div {
        display: flex;
        .oneplus {
          flex-shrink: 0;
          line-height: 42px;
        }
        .twoplus {
          flex: 1;
        }
      }
      div {
        line-height: 32px;
        text-align: left;
        margin-top: 5px;
        .color_plus {
          color: #2479ed;
          font-weight: bold;
        }
        color: #323232;
        .span_one {
          display: inline-block;
          width: 80px;
          font-weight: bold;
        }
        .span_two {
          height: auto;
        }
        .span_block {
          border-radius: 4px;
          // height: 30px;
          // line-height: 30px;
          margin-right: 15px;
        }
      }
    }
    .outer_right {
      padding-left: 30px;
      padding-right: 30px;
      flex: 1;
      .top_title {
        margin-bottom: 15px;
        padding-top: 20px;
        font-size: 12px;
        color: #aaaaaa;
      }
      .use_list {
        .list_item {
          text-align: left;
          margin-bottom: 18px;
          .title {
            font-weight: 400;
            color: #323232;
            font-size: 12px;
          }
          .content {
            display: flex;
            margin-top: 4px;
            .content_item {
              width: 90px;
              flex: 1;
              position: relative;
              .item_one {
                width: 20px;
                height: 20px;
                background: url("../../../assets/Jimage/time.png") center
                  no-repeat;
              }
              .item_two {
                width: 20px;
                height: 20px;
                background: url("../../../assets/Jimage/place.png") center
                  no-repeat;
              }
              .item_three {
                width: 20px;
                height: 20px;
                background: url("../../../assets/Jimage/device.png") center
                  no-repeat;
              }
              span {
                position: absolute;
                left: 20px;
                top: 0;
                color: #999999;
                font-size: 12px;
              }
            }
            .spacial_item {
              width: 100px;
            }
          }
        }
      }
      .bottom_content {
        color: #323232;
        font-size: 12px;
        margin-bottom: 40px;
        font-weight: 400;
        text-align: left;
      }
    }
  }
}
</style>